// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"GX-z","sponsoredTooltipWrapper":"HX-z","sponsoredTooltip":"IX-z","newCard":"JX-z"};